/**
 * @returns true to show verification before onboarding or false to show verification after onboarding
 */
export const showLinkedinVerificationBeforeOnBoarding = (onboardingCompleted: boolean) => {
  if (onboardingCompleted) {
    // existing users are excluded from experiment
    return false
  }

  // TODO: Check why feature flag sometimes returns undefined
  // Task: https://www.notion.so/zrive/Make-feature-flags-stable-1b43a00aa35d80999869f2674ee2fd1f
  // const flag = posthog.getFeatureFlag('linkedin-verfication-experiment')
  // return flag !== end

  return false
}
